import React from 'react'

import Page from '../../../components/pdf/Page'

import Header from './_shared/Header'
import HRHContent from './_shared/sections/HRHContent'
import VentureContent from './_shared/sections/VentureContent'
import TerminationContent from './_shared/sections/TerminationContent'
import Grid from './_shared/sections/Grid'
import AdditiveContent from './_shared/sections/AdditiveContent'
import AdditiveHRHContent from './_shared/sections/AdditiveHRHContent'
import AdditiveVentureContent from './_shared/sections/AdditiveVentureContent'
import Footer from './_shared/Footer'

const PdfDocument = ({ templateId }) => {
  const content = () => {
    if (templateId === 1) {
      return <HRHContent />
    }
    if (templateId === 8) {
      return <TerminationContent />
    }
    if (templateId === 9) {
      return <AdditiveContent />
    }
    if (templateId === 10) {
      return <AdditiveHRHContent />
    }
    if (templateId >= 11 && templateId <= 16) {
      return <AdditiveVentureContent templateId={templateId} />
    }
    return <VentureContent templateId={templateId} />
  }
  return (
    <Page>
      <Header />
      {content()}
      {templateId !== 1 && templateId !== 8 && <Grid templateId={templateId} />}
      <Footer templateId={templateId} />
    </Page>
  )
}

export default PdfDocument
